import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Category } from '../../models/category';

import { CategoryPage } from '../category/category';
import { SearchPage } from '../search/search';
import { DetailPage } from '../detail/detail';
import { PageBase } from '../page-base';
import { DataProvider } from '../../providers/data/data';
import { ScanProvider } from '../../providers/scan/scan';
import { AppConfig } from '../../config/app.config';
import { CategoryProvider } from '../../providers/category/category';
import { Product } from '../../models/product';
import { Banner } from '../../models/banner';
import { BannerProvider } from '../../providers/banner/banner';
import { ProductProvider } from '../../providers/product/product';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage extends PageBase {
  categories = new Array<Category>(new Category());

  banner0: Banner;
  banner1: Banner;
  banner2: Banner;

  constructor(private categoryProvider: CategoryProvider,
    private bannerProvider: BannerProvider,
    private scanProvider: ScanProvider,
    private navCtrl: NavController,
    private config: AppConfig,
    private productProvider: ProductProvider) {
    super();
    // Get categories
    this.categoryProvider.getCategories().then(value => {
      this.categories = value;
    });

    this.bannerProvider.getBanners().then(b => {
      this.banner0 = b.find(x => x.position == 0);
      this.banner1 = b.find(x => x.position == 1);
      this.banner2 = b.find(x => x.position == 2);
      if(!this.banner0) this.banner0 = b[0];
      if(!this.banner1) this.banner1 = b[0];
      if(!this.banner2) this.banner2 = b[0];
    });
  }

  private openCategory(category: string) {
    this.navCtrl.setRoot(CategoryPage, { "categoryId": category });
  }

  private openSearchPage() {
    this.navCtrl.push(SearchPage);
  }

  private scanBarcode() {
    this.scanProvider.findProduct((item: Product) => {
      this.openDetail(item);
    });
  }

  private openDetail(item: Product) {
    // this.loadingProvider.start("PRODUCT_DETAIL");
    // Open Product detail page
    this.navCtrl.push(DetailPage, { "product": item });
  }

  private openBanner(banner: Banner){
    if(banner.category_uuid) {
      this.openCategory(banner.category_uuid)
    } else if(banner.product_uuid) {
      this.productProvider.getProduct(banner.product_uuid).then(x => {
        this.openDetail(x);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts